import { useState, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import AnimatedLetters from '../AnimatedLetters'
import Loader from 'react-loaders'
import { pricingData } from '../../data/pricing'
import './index.scss'

const Checkout = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const planId = searchParams.get('plan')
    const plan = pricingData.find(p => p.id === planId)

    useEffect(() => {
        if (!plan) {
            navigate('/pricing')
        }
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [plan, navigate])

    if (!plan) return <Loader type="ball-scale-multiple" />

    return (
        <>
            <div className="container checkout-page">
                <div className="text-zone">
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['C', 'h', 'e', 'c', 'k', 'o', 'u', 't']}
                            idx={15}
                        />
                    </h1>
                    <p>
                        Review your package details below before proceeding to the secure deposit payment.
                    </p>

                    <div className="checkout-summary">
                        <h2>Package Details</h2>
                        <div className="summary-card">
                            <div className="summary-header">
                                <h3>{plan.title}</h3>
                                <span className="price">{plan.price}</span>
                            </div>
                            <div className="summary-body">
                                <p className="description">{plan.for}</p>

                                <h4>Included Features:</h4>
                                <ul>
                                    {plan.features.map((feature, idx) => (
                                        <li key={idx}>{feature}</li>
                                    ))}
                                </ul>

                                <div className="deposit-section">
                                    <h4>Deposit Required: {plan.deposit}</h4>
                                    <p className="deposit-note">{plan.depositNote}</p>
                                    <p className="refund-policy">
                                        Your deposit secures your development slot. It is fully refundable if we determine the project isn't a fit during the kickoff call.
                                    </p>
                                </div>

                                <div className="action-buttons">
                                    <a
                                        href={plan.stripeLink}
                                        className="flat-button primary"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        Proceed to Secure Payment
                                    </a>
                                    <button
                                        onClick={() => navigate('/pricing')}
                                        className="flat-button secondary"
                                    >
                                        Back to Plans
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Loader type="ball-scale-multiple" />
        </>
    )
}

export default Checkout
